import { useLayoutEffect, useRef } from 'react';
import { useTheme } from 'context/ThemeContext.jsx';
import './AdminPreviewBar.css';

export default function AdminPreviewBar({ organization, onReturn }) {
  const { theme, setTheme } = useTheme();
  const bar = useRef(null);
  useLayoutEffect(() => {
    const root = document.documentElement;
    const measure = () => root.style.setProperty('--admin-preview-height', `${bar.current?.getBoundingClientRect().height || 0}px`);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(bar.current);
    return () => { observer.disconnect(); root.style.removeProperty('--admin-preview-height'); };
  }, []);

  return <aside className="admin-preview-bar" ref={bar} aria-label="Organization admin preview">
    <div className="admin-preview-identity">
      <span className="admin-preview-badge">ADMIN VIEW</span>
      <div><strong>{organization}</strong><span>Full admin access · 15-minute session</span></div>
    </div>
    <div className="admin-preview-actions">
      <label>Preview theme<select aria-label="Preview theme" value={theme} onChange={event => setTheme(event.target.value)}>
        <option value="v1">V1 · Classic</option>
        <option value="v2">V2 · Console</option>
        <option value="v3">V3 · Jarvis</option>
      </select></label>
      <button type="button" aria-label="Return to organizations" onClick={onReturn}>← Return to organizations</button>
    </div>
  </aside>;
}
